//const apihost = 'http://iseapi.9235.net';
//const apihost = 'http://localhost:21021';
const apihost = 'http://180.153.225.130:18080';

export default {
    'baseuri': apihost,
    'common': {
        'saveschema': apihost + '/api/services/app/SalesAnalysisService/savesearchschema',
        /*保存搜索方案 */
        'schemalist': apihost + '/api/services/app/SalesAnalysisService/CommonSchemeList',
        'info': apihost + '/AbpUserConfiguration/GetAll'
    },
    'salesanalysis': {
        'searchconfig': apihost + '/api/services/app/SalesAnalysisService/SearchConfig',
        'querytag': apihost + '/api/services/app/SalesAnalysisService/QueryTag',
        'getsmartsearchkeyword': apihost + '/api/services/app/SalesAnalysisService/smartSearchKeyword',
        'savesearchschema': apihost + '/api/services/app/SalesAnalysisService/savesearchschema',
        'searchschemalist': apihost + '/api/services/app/SalesAnalysisService/searchSchemaList',
        'deletesearchschema': apihost + '/api/services/app/SalesAnalysisService/deleteSearchSchema',
        // 'search':apihost + '/api/services/app/SalesAnalysisService/search',
        'search': apihost + '/api/services/app/SaleAjaxService/Search2',
        'searchbyids': apihost + '/api/services/app/SalesAnalysisService/searchByIds',
        'searchbyresultschema': apihost + '/api/services/app/SalesAnalysisService/searchbyresultschema',
        'resultschemalist': apihost + '/api/services/app/SalesAnalysisService/resultSchemaList',
        //'getserializeobject':apihost + '/api/services/app/SalesAnalysisService/GetSerializeObject',
        //'setserializeobject':apihost + '/api/services/app/SalesAnalysisService/CreateOrUpdateSerializeObject',
        //'getpivottable':apihost + '/api/services/app/SalesAnalysisService/QueryPivotTable',
        'setserializeobject': apihost + '/api/services/app/SaleAjaxService/CreateOrUpdateSerializeObject',
        'getserializeobject': apihost + '/api/services/app/SaleAjaxService/GetSerializeObject',
        'getpivottable': apihost + '/api/services/app/SaleAjaxService/QueryPivotTable',
        // 'getpivotline':apihost + '/api/services/app/SaleAjaxService/QueryPivotline',
        'salecategories': apihost + '/api/services/app/SaleAjaxService/QuerySaleCategories',

    },
    'equip': {
        'searchequip': apihost + '/api/services/app/SalesAnalysisService/SearchEquip',
        /*搜索装备 */
        'queryequiplist': apihost + '/api/services/app/AjaxService/GetEquipmentsAttributesList',
        /*初始化装备列表 */
        'equipsearchschem': apihost + '/api/services/app/SalesAnalysisService/EquipSearchSchemList',
        // 'carsbyequip' :apihost +'/api/services/app/Client/QueryLine',
        'carsbyequip': apihost + '/api/services/app/EquipAjaxService/QueryLine',
        'queryline': apihost + '/api/services/app/EquipAjaxService/QueryLine2',
        'queryeinbaurate': apihost + '/api/services/app/AjaxService/QueryEinbaurate',
        'queryequipparams': apihost + '/api/services/app/AjaxService/queryEquipParams',
        'querypk1': apihost + '/api/services/app/AjaxService/querypk1',
        'equipparamsbymodel': apihost + '/api/services/app/AjaxService/QueryModeEquipParams',
        'Querypva': apihost + '/api/services/app/EquipAjaxService/QueryPVA',
        'InstalledRation': apihost + '/api/services/app/EquipAjaxService/InstalledRation'
    },
    'depth': {
        'timeline': apihost + '/api/services/app/DepthService/TimelineByModelName',
        /* 生命周期 */
        'priceladder': apihost + '/api/services/app/DepthService/PriceLadder',
        'PriceSkeleton': apihost + '/api/services/app/DepthService/PriceSkeleton',
        'installedRatios': apihost + '/api/services/app/DepthService/EquipmentRate',
        'dimension': apihost + '/api/services/app/DepthService/EquipmentDimension',
    },
    'report': {
        'monthly': apihost + '/api/services/app/ReportService/MonthlyReport',
        'daily': apihost + '/api/services/app/ReportService/DailyReport',
        'espionage': apihost + '/api/services/app/ReportService/SpyReport',

    },
    'home': {
        'newcarpie': apihost + '/api/services/app/ReportService/LineGroupQuery',
        'dailynews': apihost + '/api/services/app/ReportService/LineYesterdayQuery',
    },
    'user': {
        'login': apihost + '/api/TokenAuth/Authenticate',
        'logininfo': apihost + '/api/services/app/Session/GetCurrentLoginInformations'
    },
    'chart': {
        'build': apihost + '/api/services/app/ChartService/BuildData',
        'list': apihost + '/api/services/app/ChartService/QueryChartConfigs',
        'data': apihost + '/api/services/app/ChartService/QueryChartData',
        'update': apihost + '/api/services/app/ChartService/UpdateChartConfig',
        'lastdata': apihost + '/api/services/app/ChartService/LastData',
        'qn4q': apihost + '/api/services/app/ChartService/QueryNew4q',
        'queryNewCarIds': apihost + '/api/services/app/ChartService/queryNewCarIds'
    },
    'schema': {
        'myschema': apihost + '/api/services/app/SalesAnalysisService/MySchemaList',
        'userdict': apihost + '/api/services/app/SalesAnalysisService/GetUserDict',
        'delete': apihost + '/api/services/app/SalesAnalysisService/delSchemaById',
        'topublic': apihost + '/api/services/app/SalesAnalysisService/SchemaToPublic',
        'list': apihost + '/api/services/app/SalesAnalysisService/GetSchemaList',
        'copy': apihost + '/api/services/app/SalesAnalysisService/CopySchema',
    },
    'gain':{
        'getmarketsbyname':apihost+'/api/services/app/GainService/GetMarketsByName',
        'queryGainData':apihost+'/api/services/app/GainService/queryGainData',
    }
}